<mat-toolbar class="primary">
  {{ "ASTIMAX.PHONE.WIDGET.TITLE" | translate }} {{ "ASTIMAX.PHONE.WIDGET.SETTINGS.TITLE" | translate }}
  <span class="adx-toolbar-spacer"></span>
  <button mat-icon-button [mat-dialog-close]="true" aria-label="Close Button">
    <fa-icon [icon]="'xmark'"></fa-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="adx-typography">
  @if (widgetHeaderForm && phoneWidget) {
    <form [formGroup]="widgetHeaderForm" class="adx-component-form-container">
      <input hidden="hidden" matInput formControlName="_id">
      @if (!isViewDashboard()) {
        <!-- WIDGET HEADER / TITLE -->
        <h3>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.WIDGET_HEADER.SECTION_LABEL' | translate }}</h3>
        <div class="adx-row">
          <ng-container formGroupName="settings">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.WIDGET_HEADER.DISPLAY_OPTIONS.SELECT_LABEL' | translate }}</mat-label>
              <mat-select formControlName="widgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                @for (option of phoneWidget.settings.widgetHeader | keyvalue; track option) {
                  <mat-option
                    [value]="option.key" 
                    [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                    {{ getWidgetHeaderDisplayOptionText(option.key) | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </ng-container>
          <ng-container formGroupName="settings">
            <mat-slide-toggle class="adx-form-field-spacer adx-adx-form-field-align-center primary"
              formControlName="showWidgetTitle">
              <span >{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.WIDGET_HEADER.SHOW_WIDGET_TITLE' | translate }}</span>
            </mat-slide-toggle>
          </ng-container>
        </div>
        <mat-divider class="adx-section-divider"></mat-divider>
      }
      <!-- AUDIO DEVICES -->
      <h3>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SECTION_LABEL' | translate }}</h3>
      <ng-container formGroupName="settings">
        <!-- Jabra Headset Section -->
        @if (jabra.initialized) {
          <div class="adx-settings-group">
            <div class="adx-settings-group-header">
              <fa-icon [icon]="faHeadset" class="adx-settings-group-icon"></fa-icon>
              <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.JABRA.LABEL' | translate }}</span>
            </div>
            <!-- Connected Jabra device info -->
            @if (jabra.connected) {
              <div class="adx-jabra-device-info">
                <div class="adx-jabra-device-name">{{jabra.deviceName}}</div>
                <div class="adx-jabra-device-status">
                  <span class="adx-jabra-call-control-badge">
                    {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.DEVICE_STATUS_CONNECTED' | translate }}
                  </span>
                  @if (jabra.muted) {
                    <span class="adx-jabra-muted-badge">
                      {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.DEVICE_STATUS_MUTED' | translate }}
                    </span>
                  }
                  @if (jabra.onHold) {
                    <span class="adx-jabra-hold-badge">
                      {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.DEVICE_STATUS_ONHOLD' | translate }}
                    </span>
                  }
                </div>
              </div>
            }
            <!-- No connected Jabra device and no available devices -->
            @if (!jabra.connected && jabraDeviceList.length === 0) {
              <div class="adx-jabra-device-info">
                <div class="adx-jabra-device-status">{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.JABRA.NO_DEVICE_CONNECTED' | translate }}</div>
                <button mat-button mat-raised-button class="adx-test-button primary" (click)="pairJabraDevice()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.PAIR_HEADSET' | translate }}">
                  <fa-icon [icon]="faPlug"></fa-icon>
                  <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.PAIR_HEADSET' | translate }}</span>
                </button>
              </div>
            }
            <!-- Available Jabra devices list -->
            @if (jabraDeviceList && jabraDeviceList.length > 0) {
              <div class="adx-jabra-device-list">
                <div class="adx-jabra-device-list-header">{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.AVAILABLE_DEVICES_LABEL' | translate }}</div>
                @for (device of jabraDeviceList; track device) {
                  <div class="adx-jabra-device-item" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.CONNECT_DEVICE_TOOLTIP' | translate }}"
                    [ngClass]="{'selected': jabra.deviceName === device.name}"
                    (click)="selectJabraDevice(device)">
                    <fa-icon [icon]="faHeadset" class="adx-jabra-device-icon"></fa-icon>
                    {{device.name}}
                    @if (device.serialNumber) {
                      <span class="adx-jabra-device-serial">
                        ({{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.SN_LABEL' | translate }} {{device.serialNumber}})
                      </span>
                    }
                  </div>
                }
              </div>
            }
            <!-- Headset Action Buttons -->
            @if (jabra.connected) {
              <div class="adx-jabra-action-buttons">
                <button mat-button mat-raised-button class="adx-test-button primary" (click)="resetJabraHeadset()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.RESET_HEADSET_TOOLTIP' | translate }}">
                  <fa-icon [icon]="faRedo"></fa-icon>
                  <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.RESET_HEADSET' | translate }}</span>
                </button>
                <button mat-button mat-raised-button class="adx-test-button warn" (click)="disconnectJabraDevice()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.REMOVE_HEADSET_TOOLTIP' | translate }}">
                  <fa-icon [icon]="faUnlink"></fa-icon>
                  <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.HEADSET.REMOVE_HEADSET' | translate }}</span>
                </button>
              </div>
            }
          </div>
        }
        <!-- Microphone Selection -->
        <div class="adx-settings-group">
          <div class="adx-settings-group-header">
            <fa-icon [icon]="faMicrophoneIcon" class="adx-settings-group-icon"></fa-icon>
            <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.LABEL' | translate }}</span>
          </div>
          <mat-checkbox
            [checked]="useDefaultMicrophone"
            (change)="toggleDefaultMicrophone($event.checked)"
            class="primary">
            {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.USE_DEFAULT_DEVICE' | translate }}
          </mat-checkbox>
          <mat-form-field appearance="outline" class="adx-device-select-field">
            <mat-select [value]="selectedAudioInputId" (selectionChange)="changeAudioInputDevice($event.value)" [disabled]="useDefaultMicrophone">
              @if (useDefaultMicrophone) {
                <mat-option value="" selected>{{ defaultMicrophoneLabel }}</mat-option>
              }
              @for (device of audioInputDevices; track device) {
                <mat-option [value]="device.deviceId">
                  {{ device.label || (('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.LABEL' | translate) + ' ' + (audioInputDevices.indexOf(device) + 1)) }}
                </mat-option>
              }
              @if (audioInputDevices.length === 0) {
                <mat-option [disabled]="true">
                  {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.NO_MICROPHONE_DETECTED' | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <!-- Audio level visualization -->
          <div class="adx-audio-visualizer">
            @for (i of audioSegments; track i) {
              <div class="adx-segment" [class.active]="i < microphoneLevel"></div>
            }
          </div>
          <!-- Microphone test controls -->
          @if (!isTestingMicrophone) {
            <div class="adx-test-actions">
              <button mat-button mat-raised-button class="adx-test-button primary" (click)="startMicrophoneTest($event)">
                <fa-icon [icon]="faRecordVinyl"></fa-icon>
                <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.TEST_MICROPHONE' | translate }}</span>
              </button>
            </div>
          }
          <!-- Recording in progress -->
          @if (isTestingMicrophone && isRecording) {
            <div class="adx-test-actions">
              <button mat-button mat-raised-button class="adx-test-button primary" (click)="stopMicrophoneTest()">
                <span class="adx-recording-indicator"></span>
                <fa-icon [icon]="faStop"></fa-icon>
                <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.RECORDING' | translate }} ({{recordingDuration}}s)</span>
              </button>
            </div>
          }
          <!-- Playback controls -->
          @if (isTestingMicrophone && !isRecording && recordedAudioUrl) {
            <div class="adx-test-actions">
              <button mat-button mat-raised-button class="adx-test-button primary" (click)="playRecordedAudio($event)">
                <fa-icon [icon]="faPlayCircle"></fa-icon>
                <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.PLAY_RECORDING' | translate }}</span>
              </button>
              <button mat-button mat-raised-button class="adx-test-button primary" (click)="resetMicrophoneTest($event)">
                <fa-icon [icon]="faRedo"></fa-icon>
                <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.DELETE_RECORDING' | translate }}</span>
              </button>
            </div>
          }
        </div>
        <!-- Speaker Selection (only if supported) -->
        @if (isAudioOutputSelectionSupported) {
          <div class="adx-settings-group">
            <div class="adx-settings-group-header">
              <fa-icon [icon]="faHeadphones" class="adx-settings-group-icon"></fa-icon>
              <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.LABEL' | translate }}</span>
            </div>
            <mat-checkbox
              [checked]="useDefaultSpeaker"
              (change)="toggleDefaultSpeaker($event.checked)"
              class="primary">
              {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.USE_DEFAULT_DEVICE' | translate }}
            </mat-checkbox>
            <mat-form-field appearance="outline" class="adx-device-select-field">
              <mat-select [value]="selectedAudioOutputId" (selectionChange)="changeAudioOutputDevice($event.value)" [disabled]="useDefaultSpeaker">
                @if (useDefaultSpeaker) {
                  <mat-option value="" selected>{{ defaultSpeakerLabel }}</mat-option>
                }
                @for (device of audioOutputDevices; track device) {
                  <mat-option [value]="device.deviceId">
                    {{ device.label || (('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.LABEL' | translate) + ' ' + (audioOutputDevices.indexOf(device) + 1)) }}
                  </mat-option>
                }
                @if (audioOutputDevices.length === 0) {
                  <mat-option [disabled]="true">
                    {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.NO_SPEAKER_DETECTED' | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Speaker test button -->
            <div class="adx-test-actions">
              <button mat-button mat-raised-button class="adx-test-button primary" (click)="startSpeakerTest($event)" [disabled]="isTestingSpeaker">
                <fa-icon [icon]="faVolumeUp"></fa-icon>
                <span>{{ isTestingSpeaker ? ('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.PLAYING' | translate) : ('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.TEST_SPEAKER' | translate) }}</span>
              </button>
            </div>
          </div>
        }
        <!-- Message when speaker selection is not supported -->
        @if (!isAudioOutputSelectionSupported) {
          <div class="adx-settings-group">
            <div class="adx-settings-group-header">
              <fa-icon [icon]="faHeadphones" class="adx-settings-group-icon"></fa-icon>
              <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.LABEL' | translate }}</span>
            </div>
            <div class="adx-settings-unsupported-message">
              {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.SPEAKER_SELECTION_NOT_SUPPORTED' | translate }}
            </div>
          </div>
        }
        <!-- Ringing Tones -->
        @if (isAudioOutputSelectionSupported) {
          <div class="adx-settings-group">
            <div class="adx-settings-group-header">
              <fa-icon [icon]="faBell" class="adx-settings-group-icon"></fa-icon>
              <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.RINGING_TONE.LABEL' | translate }}</span>
            </div>
            <mat-checkbox
              [checked]="useDefaultRingingDevice"
              (change)="toggleDefaultRingingDevice($event.checked)"
              class="primary">
              {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.USE_DEFAULT_DEVICE' | translate }}
            </mat-checkbox>
            <mat-form-field appearance="outline" class="adx-device-select-field">
              <mat-select [value]="selectedRingingDeviceId" (selectionChange)="changeRingingDevice($event.value)" [disabled]="useDefaultRingingDevice">
                @if (useDefaultRingingDevice) {
                  <mat-option value="" selected>{{ defaultSpeakerLabel }}</mat-option>
                }
                @for (device of audioOutputDevices; track device) {
                  <mat-option [value]="device.deviceId">
                    {{ device.label || (('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.LABEL' | translate) + ' ' + (audioOutputDevices.indexOf(device) + 1)) }}
                  </mat-option>
                }
                @if (audioOutputDevices.length === 0) {
                  <mat-option [disabled]="true">
                    {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.NO_SPEAKER_DETECTED' | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <!-- Ringing tone test button -->
            <div class="adx-test-actions">
              <button mat-button mat-raised-button class="adx-test-button primary" (click)="testRingingTone($event)" [disabled]="isTestingRingingTone">
                <fa-icon [icon]="faBell"></fa-icon>
                <span>{{ isTestingRingingTone ? ('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.PLAYING' | translate) : ('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.RINGING_TONE.TEST_RINGING_TONE' | translate) }}</span>
              </button>
            </div>
          </div>
        }
        <!-- Message when ringing tone speaker selection is not supported -->
        @if (!isAudioOutputSelectionSupported) {
          <div class="adx-settings-group">
            <div class="adx-settings-group-header">
              <fa-icon [icon]="faBell" class="adx-settings-group-icon"></fa-icon>
              <span>{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.RINGING_TONE.LABEL' | translate }}</span>
            </div>
            <div class="adx-settings-unsupported-message">
              {{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.SPEAKER.SPEAKER_SELECTION_NOT_SUPPORTED' | translate }}
            </div>
          </div>
        }
        <!-- Device permissions message -->
        @if (audioInputDevices.length === 0 && audioOutputDevices.length === 0) {
          <div class="adx-settings-help-message">
            <p>{{ ('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.NO_MICROPHONE_DETECTED' | translate) + '. ' + ('ASTIMAX.PHONE.WIDGET.SETTINGS.AUDIO_DEVICES.MICROPHONE.GRANT_PERMISSIONS_MESSAGE' | translate) }}</p>
          </div>
        }
      </ng-container>
    </form>
  }
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close  (click)="onCloseDialog()">{{
  'ASTIMAX.PHONE.WIDGET.SETTINGS.CANCEL' | translate }}</button>
  <button mat-button mat-raised-button class="primary" type="submit" (click)="onSubmit()"
  [disabled]="isValidForm()">{{ 'ASTIMAX.PHONE.WIDGET.SETTINGS.SAVE' | translate }}</button>
</mat-dialog-actions>
